var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidayIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:none;}\n\t.st2{fill:url(#SVGID_00000139284995631685046280000001111506393288782214_);}\n\t.st3{fill:url(#SVGID_00000030458418674141065390000006175278393215756452_);}\n\t.st4{fill:url(#SVGID_00000183206580278382684210000011281379449506902417_);}\n\t.st5{fill:url(#SVGID_00000029008798770869675840000007953599769866143378_);}\n\t.st6{fill:url(#SVGID_00000074428046262436541630000010720936102352060330_);}\n\t.st7{fill:url(#SVGID_00000064333406944341517230000003936559585795915151_);}\n\t.st8{fill:url(#SVGID_00000121981078607290351980000016822764708274784926_);}\n\t.st9{fill:url(#SVGID_00000132781184460472639910000008664952288583394205_);}\n\t.st10{fill:url(#SVGID_00000044151679909804594480000013610395523201622462_);}\n\t.st11{fill:url(#SVGID_00000137813584920246666450000013685745830719342983_);}\n\t.st12{fill:url(#SVGID_00000115492832700570071810000009789801813690778523_);}\n\t.st13{fill:url(#SVGID_00000003088847618514586800000009072375620061013641_);}\n\t.st14{fill:url(#SVGID_00000168796727727284681970000013055410131345949627_);}\n\t.st15{fill:url(#SVGID_00000006669896562129329980000001383210621723455399_);}\n\t.st16{fill:url(#SVGID_00000032628124069763893300000007331780188622442672_);}\n\t.st17{fill:url(#SVGID_00000105403781182360106260000011422703807257522608_);}\n\t.st18{fill:url(#SVGID_00000180336115133774248500000009188197949029501075_);}\n\t.st19{fill:url(#SVGID_00000049921640583584429700000000427143782260835259_);}\n\t.st20{fill:url(#SVGID_00000018959417774638378890000003198736129668879252_);}\n\t.st21{fill:url(#SVGID_00000181807681828424463240000002320117765753341339_);}\n\t.st22{fill:url(#SVGID_00000116196256624269117340000009259221516593010109_);}\n\t.st23{fill:#1F3151;}\n\t.st24{fill:url(#SVGID_00000030449534054372004950000014911917059901364665_);}\n\t.st25{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -239.5745,
    y1: -19.6771,
    x2: -202.3572,
    y2: -12.0039,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-202.9,50.5c-2.2,0-4.5-0.1-6.6,1c-1.8,0.9-3.6,1.7-5.4,2.7c-0.6,0.3-1,0.3-1.6,0.1c-3.8-1.4-7.6-2.8-11.3-4.3 c-1.3-0.5-2.4-0.6-3.6,0.2c-1.2,0.8-2.6,1.3-3.9,2c3.6,2.3,7.1,4.6,10.6,6.9c-1.8,0.9-3.5,1.7-5.2,2.6c-0.9,0.5-1.6,0.5-2.4-0.1 c-1-0.7-2-1.6-3.1-1.6c-1,0-2.1,0.9-3.2,1.4c-0.6,0.3-0.5,0.5-0.2,0.9c1.7,1.9,3.3,3.8,4.9,5.8c0.3,0.4,0.6,0.4,1,0.4 c2.8,0,5.5,0,8.2,0c0.3,0,0.6,0,0.9-0.1c5.8-2.9,11.5-5.7,17.3-8.7c2.4-1.3,4.1-3.4,5.1-5.9C-200.6,52.2-201.4,50.5-202.9,50.5z  M-202.1,53.4c-1,2.5-2.7,4.4-5.1,5.7c-5.5,2.8-11,5.5-16.5,8.3c-0.3,0.2-0.7,0.2-1,0.2c-2.6,0-5.1,0-7.7,0c-0.3,0-0.7,0-0.9-0.3 c-1.4-1.7-2.9-3.4-4.3-5.1c0.1-0.1,0.1-0.1,0.1-0.1c1.4-1.1,2.7-1.2,4.1,0c1.5,1.3,3,1.2,4.7,0.2c1.9-1.2,3.9-2,6-3 c-3.6-2.3-7.1-4.5-10.7-6.9c1.3-0.6,2.4-1.2,3.6-1.9c0.4-0.2,0.7,0,1,0.1c4.2,1.6,8.5,3.1,12.7,4.7c0.5,0.2,0.9,0.2,1.3-0.1 c1.9-1,3.9-1.9,5.8-2.9c1.9-1,4-0.9,6.1-0.9C-202.1,51.5-201.7,52.5-202.1,53.4z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-160,47.2c-4.7,0-8.6,3.9-8.5,8.6c0,4.7,3.9,8.5,8.6,8.5c4.7,0,8.5-3.9,8.5-8.6 C-151.5,51-155.3,47.2-160,47.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173874223650943501320000000630807049924932257_",
    gradientUnits: "userSpaceOnUse",
    x1: -168.4805,
    y1: -27.1648,
    x2: -151.4794,
    y2: -27.1648,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173874223650943501320000000630807049924932257_)"
    },
    d: "M-152.5,68.6c-2.5,0-4.9,0-7.4,0 c-2.6,0-5.1,0-7.7,0c-0.5,0-1,0-1,0.6c0,0.5,0.6,0.5,1,0.5c5,0,10,0,15.1,0c0.4,0,1,0.1,0.9-0.5C-151.5,68.6-152,68.6-152.5,68.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150098149874612611220000003594412045963928490_",
    gradientUnits: "userSpaceOnUse",
    x1: -174.9764,
    y1: -18.0678,
    x2: -145.0056,
    y2: -18.0678,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150098149874612611220000003594412045963928490_)"
    },
    d: "M-145,47.5c0-2.7-1.8-4.5-4.6-4.5 c-6.9,0-13.8,0-20.8,0c-2.7,0-4.6,1.8-4.6,4.5c0,8.4,0,16.8,0,25.3c0,2.8,1.9,4.5,4.6,4.5c6.9,0,13.8,0,20.7,0 c2.9,0,4.6-1.8,4.7-4.7c0-4.1,0-8.3,0-12.4C-145,55.9-145,51.7-145,47.5z M-146.1,72.3c0,2.7-1.2,3.9-3.8,3.9c-6.8,0-13.6,0-20.3,0 c-2.5,0-3.7-1.3-3.7-3.8c0-8.2,0-16.4,0-24.6c0-2.5,1.3-3.8,3.7-3.8c6.8,0,13.6,0,20.4,0c2.5,0,3.7,1.2,3.7,3.7c0,4.1,0,8.3,0,12.4 C-146.1,64.1-146.1,68.2-146.1,72.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157289240304560743800000001491541226534456223_",
    gradientUnits: "userSpaceOnUse",
    x1: -168.5502,
    y1: -13.775,
    x2: -151.45,
    y2: -13.775,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157289240304560743800000001491541226534456223_)"
    },
    d: "M-160,47.2c-4.7,0-8.6,3.9-8.5,8.6 c0,4.7,3.9,8.5,8.6,8.5c4.7,0,8.5-3.9,8.5-8.6C-151.5,51-155.3,47.2-160,47.2z M-152.6,54.6c0.1,0.5-0.1,0.7-0.6,0.7 c-0.1,0-0.1,0-0.2,0c-0.9,0-1.9,0.3-2.6-0.1c-0.7-0.4-0.4-1.6-0.6-2.5c-0.3-1.4-0.9-2.8-1.9-4.1C-155.5,49-152.8,51.8-152.6,54.6z  M-159.3,49.1c1.3,1.7,1.7,3.6,2,5.7c0.1,0.4-0.1,0.6-0.5,0.5c-0.7,0-1.4,0-2.1,0c-0.5,0-0.9,0-1.4,0c-1.4,0-1.4,0-1.2-1.3 c0.2-1.8,0.8-3.4,1.9-4.8C-160.2,48.5-159.9,48.4-159.3,49.1z M-161.5,48.6c-1.5,1.8-1.9,3.9-2.1,6.1c-0.1,0.5-0.2,0.7-0.7,0.7 c-0.8,0-1.7,0-2.6,0c-0.3,0-0.5,0-0.5-0.4C-167.5,52.2-164.4,48.8-161.5,48.6z M-167.4,57.1c-0.1-0.5,0-0.8,0.6-0.8 c0.9,0,2-0.2,2.7,0.1c0.9,0.4,0.5,1.6,0.7,2.5c0.3,1.5,0.9,2.8,1.9,4.2C-164.6,62.4-166.9,60-167.4,57.1z M-160.5,62.7 c-1.4-1.7-1.9-3.7-2.1-5.8c-0.1-0.5,0.1-0.6,0.6-0.6c0.7,0,1.4,0,2.1,0c0.2,0,0.4,0,0.5,0c2.3,0,2.3,0,1.8,2.2 c-0.3,1.6-0.9,3-1.9,4.2C-159.8,63.1-160.1,63.1-160.5,62.7z M-158.4,63c1.4-1.9,1.9-3.9,2.1-6c0-0.6,0.3-0.9,0.9-0.8 c0.7,0.1,1.5,0,2.2,0c0.6,0,0.7,0.2,0.6,0.8C-152.9,59.8-155.4,62.5-158.4,63z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2,5.1c-8.1,0-16.2,0-24.4,0C7.1,5.1,6.9,5.3,6.9,6c0,4.7,0,9.4,0,14.1c0,4.8,0,9.5,0,14.2 c0,0.6,0.1,0.9,0.8,0.9c2.9,0,5.8,0,8.6,0c0.6,0,0.7-0.2,0.7-0.8c0-1.2-0.1-2.3,0-3.5c0.2-1.7,1.5-2.9,3.1-2.8 c1.6,0.1,2.8,1.3,2.8,3.1c0,1,0,2.1,0,3.1c0,0.6,0.1,0.9,0.8,0.8c2.8,0,5.6,0,8.4,0c0.7,0,0.9-0.2,0.9-0.9c0-9.5,0-18.9,0-28.4 C33.1,5.2,32.8,5.1,32.2,5.1z M25.5,8.7c1-0.3,2.1-0.2,3.1,0c0.9,0.2,1,1.1,1,1.9c-0.1,1,0.4,2.2-0.9,2.8c-0.5,0.2-1,0.1-1.5,0.1 c-0.6,0-1.1,0.1-1.6-0.1c-0.9-0.3-1-1.1-1-1.9C24.6,10.5,24.1,9.1,25.5,8.7z M17.6,9.6c0.1-0.6,0.6-1,1.2-1c0.4,0,0.8,0,1.2,0 c0,0,0,0,0,0c0.4,0,0.7,0,1.1,0c0.7,0,1.1,0.4,1.3,1c0.2,0.9,0.2,1.9,0,2.8c-0.2,0.9-0.9,1.2-1.8,1.1c-1.1-0.1-2.5,0.6-3-1 C17.3,11.6,17.4,10.6,17.6,9.6z M22.5,19.6c0,0.9-0.1,1.6-1.1,1.9c-0.4,0.1-0.9,0-1.4,0s-1,0.1-1.4,0c-0.9-0.2-1.2-0.9-1.1-1.8 c0.1-1.1-0.5-2.5,1-3c0.9-0.3,2-0.2,2.9,0C22.9,17.1,22.4,18.5,22.5,19.6z M10.5,9.8c0.1-0.7,0.6-1.2,1.3-1.2c0.4,0,0.7,0,1.1,0 c0,0,0,0,0,0c0.5,0,0.9-0.1,1.4,0c0.9,0.2,1.2,0.9,1.1,1.8c-0.1,1.1,0.5,2.5-1.1,3c-0.9,0.3-1.9,0.1-2.9,0c-0.6-0.1-0.9-0.5-1-1.1 C10.5,11.5,10.4,10.6,10.5,9.8z M11.5,21.4c-1.7-0.6-0.9-2.2-1-3.4c-0.1-0.9,0.5-1.4,1.5-1.4c0.3,0,0.7,0,1,0c0,0,0,0,0,0 c0.5,0,0.9-0.1,1.4,0c1,0.2,1.1,1,1.1,1.9c-0.1,1.1,0.4,2.5-1.1,2.9C13.5,21.7,12.4,21.7,11.5,21.4z M24.8,26.9 c-0.4,0.4-0.6,0-0.8-0.2c-1.1-1-2.4-1.6-4.1-1.6c-1.4,0-2.7,0.5-3.9,1.6c-0.2,0.2-0.4,0.6-0.8,0.3c-0.4-0.4-0.1-0.6,0.2-0.9 c2.3-2.5,6.9-2.6,9.2,0C24.9,26.3,25.2,26.6,24.8,26.9z M28.5,21.4c-0.9,0.3-1.9,0.1-2.9,0c-0.4,0-0.8-0.3-0.9-0.7 c-0.3-1.1-0.4-2.3,0-3.3c0.4-1.1,1.5-0.7,2.3-0.7c0.5,0,1-0.1,1.4,0c0.9,0.2,1.2,1,1.1,1.8C29.5,19.5,30,21,28.5,21.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.1,29.1c-1.2,0-2,0.8-2.1,2c0,0.8,0,1.5,0,2.3c0,1.7,0,1.7,1.7,1.7c2.4,0,2.4,0,2.4-2.3c0-0.5,0-1.1,0-1.6 C22,29.9,21.2,29.1,20.1,29.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061453909396453006540000001321154016883362231_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.0556,
    y1: 16.4043,
    x2: 24.9828,
    y2: 16.4043,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061453909396453006540000001321154016883362231_)"
    },
    d: "M15.4,26c-0.2,0.3-0.6,0.6-0.2,0.9 c0.4,0.4,0.6-0.1,0.8-0.3c1.1-1,2.4-1.6,3.9-1.6c1.6,0,3,0.6,4.1,1.6c0.2,0.2,0.4,0.6,0.8,0.2s0.1-0.6-0.2-0.9 C22.3,23.5,17.7,23.5,15.4,26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129191639939307996260000008856007403986165898_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9991,
    y1: 21.9432,
    x2: 36.0011,
    y2: 21.9432,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129191639939307996260000008856007403986165898_)"
    },
    d: "M35.4,35.1c-0.1,0-0.3,0-0.4,0 c-0.8,0.1-1-0.2-1-1c0-9.2,0-18.3,0-27.5c0-0.5-0.1-1.1,0.1-1.5C34.3,4.8,35,5.1,35.4,5C35.8,5,36,4.8,36,4.5C36,4.2,35.8,4,35.5,4 c-0.2,0-0.3,0-0.5,0C25,4,15,4,5,4C4.6,4,4,3.9,4,4.5C4,5.1,4.6,5.1,5,5c0.8-0.1,1,0.2,1,1c0,9.2,0,18.5,0,27.7c0,1,0,1.7-1.3,1.4 C4.3,35,4,35.2,4,35.6c0,0.4,0.3,0.6,0.7,0.5c0.2,0,0.4,0,0.6,0c4.9,0,9.8,0,14.7,0c4.5,0,9,0,13.5,0c0.6,0,1.3,0,1.9,0 c0.3,0,0.6-0.1,0.6-0.5C36,35.2,35.7,35.1,35.4,35.1z M19.6,35.1c-1.7,0-1.7,0-1.7-1.7c0-0.8,0-1.5,0-2.3c0.1-1.3,0.9-2.1,2.1-2 c1.2,0,1.9,0.8,1.9,2.1c0,0.5,0,1.1,0,1.6C22,35.1,22,35.1,19.6,35.1z M33.1,34.3c0,0.7-0.1,0.9-0.9,0.9c-2.8,0-5.6,0-8.4,0 c-0.7,0-0.8-0.2-0.8-0.8c0-1,0-2.1,0-3.1c0-1.7-1.2-3-2.8-3.1c-1.5-0.1-2.9,1-3.1,2.8c-0.1,1.2-0.1,2.3,0,3.5c0,0.5,0,0.8-0.7,0.8 c-2.9,0-5.8,0-8.6,0c-0.7,0-0.8-0.3-0.8-0.9c0-4.8,0-9.5,0-14.2c0-4.7,0-9.4,0-14.1c0-0.7,0.2-0.9,0.9-0.9c8.1,0,16.2,0,24.4,0 c0.7,0,0.9,0.1,0.9,0.9C33.1,15.4,33.1,24.9,33.1,34.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121978731197145351830000009616727198350984620_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4722,
    y1: 30.9391,
    x2: 15.514,
    y2: 30.9391,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121978731197145351830000009616727198350984620_)"
    },
    d: "M15.5,10.4c0.1-0.8-0.2-1.6-1.1-1.8 c-0.4-0.1-0.9,0-1.4,0c0,0,0,0,0,0c-0.4,0-0.7,0-1.1,0c-0.8,0-1.3,0.5-1.3,1.2c-0.1,0.8-0.1,1.7,0,2.5c0.1,0.6,0.4,1.1,1,1.1 c1,0.1,2,0.2,2.9,0C16,12.9,15.4,11.5,15.5,10.4z M12.9,12.6c-1.4,0-1.4,0-1.4-1.5c0-1.5,0-1.5,1.5-1.5c1.5,0,1.5,0,1.5,1.5 C14.5,12.6,14.5,12.6,12.9,12.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016774706251973221600000000037767408162742433_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.5095,
    y1: 31.0134,
    x2: 29.5487,
    y2: 31.0134,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016774706251973221600000000037767408162742433_)"
    },
    d: "M29.5,10.6c0-0.8-0.1-1.7-1-1.9 c-1-0.2-2.1-0.3-3.1,0c-1.4,0.5-0.9,1.8-1,2.9c-0.1,0.8,0.1,1.6,1,1.9c0.5,0.1,1,0.1,1.6,0.1c0.5,0,1,0.1,1.5-0.1 C29.9,12.8,29.5,11.6,29.5,10.6z M27,12.6c-1.4,0-1.4,0-1.4-1.6c0-1.5,0-1.5,1.5-1.5c1.5,0,1.5,0,1.5,1.6 C28.5,12.6,28.5,12.6,27,12.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172412468109372448240000002631093717885594810_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4767,
    y1: 22.9886,
    x2: 22.5362,
    y2: 22.9886,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172412468109372448240000002631093717885594810_)"
    },
    d: "M21.4,16.7c-0.9-0.2-2-0.2-2.9,0 c-1.6,0.5-0.9,1.9-1,3c-0.1,0.8,0.2,1.6,1.1,1.8c0.5,0.1,0.9,0,1.4,0s1,0.1,1.4,0c1-0.2,1.1-1,1.1-1.9 C22.4,18.5,22.9,17.1,21.4,16.7z M20,20.6c-1.5,0-1.5,0-1.5-1.6c0-1.4,0-1.4,1.5-1.4c1.5,0,1.5,0,1.5,1.5 C21.5,20.6,21.5,20.6,20,20.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144309799985303022220000006872962513577731737_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4284,
    y1: 30.937,
    x2: 22.5518,
    y2: 30.937,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144309799985303022220000006872962513577731737_)"
    },
    d: "M22.4,9.6c-0.1-0.7-0.6-1-1.3-1 c-0.4,0-0.7,0-1.1,0c0,0,0,0,0,0c-0.4,0-0.8,0-1.2,0c-0.6,0-1.1,0.4-1.2,1c-0.2,0.9-0.3,2,0,2.9c0.5,1.6,2,0.9,3,1 c0.8,0.1,1.6-0.1,1.8-1.1C22.6,11.5,22.6,10.6,22.4,9.6z M20,12.6c-1.5,0-1.5,0-1.5-1.6c0-1.5,0-1.5,1.5-1.5c1.5,0,1.5,0,1.5,1.6 C21.5,12.6,21.5,12.6,20,12.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160885865234515155460000003345141586631523492_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4082,
    y1: 22.8882,
    x2: 15.5061,
    y2: 22.8882,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160885865234515155460000003345141586631523492_)"
    },
    d: "M15.5,18.5c0.1-0.9-0.1-1.6-1.1-1.9 c-0.4-0.1-0.9,0-1.4,0c0,0,0,0,0,0c-0.3,0-0.7,0-1,0c-0.9,0-1.5,0.5-1.5,1.4c0.1,1.2-0.7,2.8,1,3.4c0.9,0.3,2,0.2,2.9,0 C15.9,21,15.4,19.6,15.5,18.5z M13,20.6c-1.5,0-1.5,0-1.5-1.6c0-1.5,0-1.5,1.6-1.5c1.5,0,1.5,0,1.5,1.6C14.5,20.6,14.5,20.6,13,20.6 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106834363445479523950000017179097503792556423_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.462,
    y1: 22.9183,
    x2: 29.5637,
    y2: 22.9183,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106834363445479523950000017179097503792556423_)"
    },
    d: "M29.5,18.4c0.1-0.8-0.2-1.6-1.1-1.8 c-0.5-0.1-0.9,0-1.4,0c-0.8,0-1.9-0.3-2.3,0.7s-0.3,2.2,0,3.3c0.1,0.4,0.5,0.7,0.9,0.7c1,0,2,0.2,2.9,0C30,21,29.5,19.5,29.5,18.4z  M27,20.6c-1.5,0-1.5,0-1.5-1.6c0-1.5,0-1.5,1.5-1.5c1.5,0,1.5,0,1.5,1.7C28.5,20.6,28.5,20.6,27,20.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158022213376281683110000003299930680689602236_",
    gradientUnits: "userSpaceOnUse",
    x1: -232.6771,
    y1: -63.6047,
    x2: -226.4163,
    y2: -63.6047,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158022213376281683110000003299930680689602236_)"
    },
    d: "M-229.5,106.1c-0.8,0-1.5,0-2.3,0 c-0.4,0-0.8-0.1-0.8-0.6c0-0.4,0.4-0.5,0.8-0.5c1.6,0,3.2,0,4.8,0c0.4,0,0.8,0.1,0.7,0.6c0,0.4-0.4,0.5-0.8,0.5 C-228,106.1-228.7,106.1-229.5,106.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183226307733753099690000000667689483165938845_",
    gradientUnits: "userSpaceOnUse",
    x1: -236.9825,
    y1: -78.0656,
    x2: -202.9925,
    y2: -78.0656,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183226307733753099690000000667689483165938845_)"
    },
    d: "M-207.5,105.1c-2.6,0-5.2,0-7.9,0 c-5.2,0-4-0.5-8.2,2.7c-0.5,0.4-1,0.5-1.6,0.5c-2.4,0-4.8,0-7.2,0c-2.8,0-4.6,1.8-4.6,4.6c0,5.9,0,11.8,0,17.7 c0,2.8,1.8,4.6,4.6,4.6c4.1,0,8.2,0,12.3,0c4.2,0,8.4,0,12.5,0c2.6,0,4.5-1.8,4.5-4.5c0-7,0-14,0-21 C-203,106.9-204.8,105.1-207.5,105.1z M-236,112.9c0-2.2,1.3-3.5,3.5-3.5c2.5,0,5.1,0,7.6,0c0.6,0,1.2-0.1,1.6-0.6 c2.2-2.3,4.9-3,8-2.7c2.5,0.2,5.1,0,7.6,0.1c2.2,0,3.4,1.3,3.5,3.4c0,1.4,0,2.7,0,4.1c0,1.4,0,2.7,0,4.1c0,0.5-0.1,0.8-0.7,0.7 c-2.4,0-4.9,0-7.3,0c-0.7,0-0.8-0.4-1.1-0.8c-2.6-4.4-8.4-5.3-12.2-1.9c-0.7,0.6-1.3,1.3-1.7,2.2c-0.2,0.4-0.5,0.6-1,0.6 c-2.4,0-4.8,0-7.2,0c-0.7,0-0.8-0.3-0.8-0.9C-235.9,116-236,114.4-236,112.9z M-213.1,121.7c0,3.8-3.1,6.9-6.9,6.9 c-3.9,0-6.9-3.1-6.9-7c0-3.9,3.1-7,6.9-7C-216.1,114.7-213,117.9-213.1,121.7z M-204,130.6c0,2.1-1.3,3.4-3.4,3.4 c-4.2,0-8.4,0-12.5,0c-4.1,0-8.2,0-12.3,0c-2.3,0-3.6-1.3-3.6-3.6c0-3.3,0-6.6,0-9.9c0-0.8,0.2-1,1-1c2.2,0.1,4.3,0,6.5,0 c0.6,0,0.8,0,0.7,0.8c-0.5,3.4,0.7,6.2,3.5,8c2.8,1.8,5.8,1.8,8.6,0c2.9-1.8,4-4.6,3.6-8c-0.1-0.7,0-0.9,0.8-0.9 c2.2,0.1,4.3,0,6.5,0c0.6,0,0.9,0.1,0.9,0.8C-204.1,123.8-204,127.2-204,130.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041999691902867095210000011040904529138834580_",
    gradientUnits: "userSpaceOnUse",
    x1: -150.7224,
    y1: -80.3751,
    x2: -146.152,
    y2: -80.3751,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041999691902867095210000011040904529138834580_)"
    },
    d: "M-148.4,120.1c-1.3,0-2.3,1-2.3,2.4 c0,1.3,1,2.2,2.3,2.3c1.3,0,2.3-0.9,2.3-2.3C-146.1,121-147.1,120.1-148.4,120.1z M-148.5,123.5c-0.7,0-1.2-0.5-1.1-1.2 s0.5-1.1,1.2-1.1s1.1,0.5,1.1,1.2C-147.3,123.1-147.7,123.5-148.5,123.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036945568278844416320000003573678119399698836_",
    gradientUnits: "userSpaceOnUse",
    x1: -173.8227,
    y1: -80.3694,
    x2: -169.2523,
    y2: -80.3694,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036945568278844416320000003573678119399698836_)"
    },
    d: "M-171.6,120.1c-1.3,0-2.2,1-2.2,2.3 c0,1.3,1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3C-169.3,121-170.2,120-171.6,120.1z M-171.4,123.5c-0.8,0-1.3-0.4-1.3-1.2 c0-0.7,0.4-1.2,1.1-1.2c0.7,0,1.2,0.4,1.2,1.1C-170.4,123.1-170.8,123.4-171.4,123.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117668098151838362110000002546097344455862691_",
    gradientUnits: "userSpaceOnUse",
    x1: -178.4918,
    y1: -78.0603,
    x2: -141.5087,
    y2: -78.0603,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117668098151838362110000002546097344455862691_)"
    },
    d: "M-141.6,122c-0.1-2.4-1.3-4.3-3.4-5.6 c-0.6-0.3-0.9-0.8-1-1.4c-0.7-2.4-1.4-4.9-2.1-7.3c-0.7-2.4-2.7-3.8-5.2-3.8c-2.2,0-4.5,0-6.7,0c-2.1,0-4.2,0-6.4,0 c-3.1,0-4.9,1.4-5.8,4.4c-0.6,2.3-1.3,4.5-1.9,6.8c-0.2,0.6-0.5,1-1.1,1.4c-1.9,1.1-3.2,2.8-3.3,5.1c-0.3,4.2-0.1,8.4-0.1,12.6 c0,1.4,1,2.1,2.4,2.1c0.7,0,1.5,0,2.2,0c1.4-0.1,2.2-0.9,2.3-2.2c0-0.9,0-1.8,0-2.8c0-0.6,0.2-0.8,0.8-0.8c7.2,0,14.4,0,21.6,0 c0.6,0,0.8,0.1,0.8,0.8c-0.1,0.9-0.1,1.8,0,2.8c0.1,1.4,1,2.2,2.4,2.2c0.7,0,1.5,0,2.2,0c1.4-0.1,2.3-0.9,2.3-2.2 C-141.5,130-141.5,126-141.6,122z M-170.7,107.9c0.7-2.1,2-2.8,4.1-2.8c4.5,0,9,0,13.5,0c1.8,0,3.3,1,3.9,2.7 c0.8,2.3,1.4,4.7,2.1,7.1c0.2,0.8-0.3,0.6-0.7,0.6c-8.3,0-16.6,0-25.1,0C-172.2,112.9-171.5,110.4-170.7,107.9z M-172.8,134.2 c-0.7,1.5-2.2,0.6-3.3,0.8c-0.8,0.1-1.2-0.4-1.3-1.2c-0.1-1,0-1.9,0-2.9c0-0.5,0.2-0.6,0.6-0.6c0.6,0,1.2,0,1.7,0 c2.3,0,2.3,0,2.3,2.3C-172.7,133.3-172.6,133.8-172.8,134.2z M-160.1,129.3c-5.3,0-10.7,0-16,0c-1.1,0-1.3-0.3-1.2-1.3 c0.1-2.3-0.2-4.5,0.2-6.8c0.5-2.8,2.7-4.7,5.6-4.7c7.7,0,15.5,0,23.2,0c3.2,0,5.6,2.2,5.7,5.4c0.1,2.2,0,4.4,0.1,6.6 c0,0.9-0.5,0.7-1,0.7C-149.1,129.3-154.6,129.3-160.1,129.3z M-142.7,134.2c-0.7,1.5-2.2,0.6-3.3,0.8c-0.8,0.1-1.2-0.4-1.3-1.2 c0-1,0-1.9,0-2.9c0-0.5,0.2-0.6,0.6-0.6c0.6,0,1.1,0,1.7,0c2.3,0,2.3,0,2.3,2.3C-142.6,133.3-142.5,133.8-142.7,134.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014601941285369280320000005023355119130329233_",
    gradientUnits: "userSpaceOnUse",
    x1: -119,
    y1: -78.749,
    x2: -110.477,
    y2: -78.749,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014601941285369280320000005023355119130329233_)"
    },
    d: "M-115.2,126.8c0-2.4,0-4.8,0-7.2 c0-0.6-0.1-0.7-0.7-0.7c-2.3,0-3.1-0.8-3.1-3.2c0-2.6,0-5.3,0-7.9c0-0.2,0-0.4,0-0.6c0-0.3,0.1-0.7,0.5-0.7c0.4,0,0.4,0.4,0.4,0.7 c0,1.3,0,2.7,0,4c0,1.6,0,3.2,0,4.8c0,1.5,1.1,2.4,2.6,1.9c0.5-0.1,0.3-0.5,0.3-0.8c0-3,0-6,0-9c0-0.2,0-0.4,0-0.6 c0-0.4-0.1-1,0.5-1c0.6,0,0.4,0.6,0.4,1c0,3.2,0,6.3,0,9.5c0,0.7,0.1,0.9,0.9,0.9c1.6-0.1,2-0.4,2-2c0-2.7,0-5.4,0-8.2 c0-0.2,0-0.4,0-0.7c0-0.3,0.2-0.6,0.5-0.6c0.3,0,0.4,0.3,0.4,0.6c0,0.4,0,0.8,0,1.2c0,2.6,0,5.3,0,7.9c0,1.7-0.9,2.7-2.6,2.6 c-0.9,0-1.2,0.2-1.2,1.2c0.1,4.6,0,9.3,0,13.9c0,0.2,0,0.5,0,0.8c0,0.2-0.2,0.3-0.4,0.4c-0.2,0-0.4-0.1-0.4-0.3 c-0.1-0.3-0.1-0.6-0.1-0.8C-115.2,131.5-115.2,129.1-115.2,126.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110451922158673924780000015885265119072256146_",
    gradientUnits: "userSpaceOnUse",
    x1: -112.0117,
    y1: -88.6262,
    x2: -86.02,
    y2: -88.6262,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110451922158673924780000015885265119072256146_)"
    },
    d: "M-86,126.6c-1.9,4.1-5,6.8-9.4,8 c-6.4,1.7-13.2-1.3-16.2-7.2c-0.1-0.3-0.7-0.7-0.1-1c0.6-0.4,0.7,0.2,0.9,0.6c2.8,5,7.2,7.4,12.9,7c4.7-0.3,8.3-2.7,10.6-6.8 C-87.1,126.6-86.8,126.2-86,126.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108999954508401481230000017621081005722194347_",
    gradientUnits: "userSpaceOnUse",
    x1: -108.5516,
    y1: -66.8641,
    x2: -89.5615,
    y2: -66.8641,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108999954508401481230000017621081005722194347_)"
    },
    d: "M-89.9,111.1c-4.5-4.3-12.5-5.4-18.6,0.2 c-0.2-0.7,0-1.2,0.6-1.7c5.2-4.1,12.8-4,17.8,0.2C-89.5,110.2-89.4,110.5-89.9,111.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093174530162164080420000003286682685771149242_",
    gradientUnits: "userSpaceOnUse",
    x1: -88.6624,
    y1: -78.7364,
    x2: -81.0026,
    y2: -78.7364,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093174530162164080420000003286682685771149242_)"
    },
    d: "M-81,107.7c-0.1-0.9-0.8-1.4-1.7-1.1 c-2.9,1.2-5,3.1-5.6,6.2c-0.7,3.3-0.3,6.8-0.2,10.1c0,1,0.8,1.6,1.9,1.6c1.2,0,2.5,0.1,3.7,0c0.9-0.1,1,0.3,1,1.1 c-0.1,2.7,0,5.4,0,8.2c0,0.2,0,0.4,0,0.7c0,0.3,0.2,0.6,0.5,0.6c0.3,0,0.4-0.3,0.4-0.6c0-0.2,0-0.4,0-0.7c0-4.2,0-8.5,0-12.7 c0-3.7,0-7.3,0-11C-81,109.2-81,108.5-81,107.7z M-82.7,123.6c-1.3-0.1-2.5,0-3.8,0c-0.7,0-1.2-0.3-1.2-1.1c0.1-3-0.2-6,0.2-9 c0.4-3,2.4-4.8,5-6c0.7-0.3,0.6,0.3,0.6,0.7c0,2.4,0,4.9,0,7.3c0,2.4,0,4.9,0,7.3C-81.9,123.4-82.1,123.6-82.7,123.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011022408924468663300000009475774160493194125_",
    gradientUnits: "userSpaceOnUse",
    x1: -107.59,
    y1: -78.755,
    x2: -90.51,
    y2: -78.755,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011022408924468663300000009475774160493194125_)"
    },
    d: "M-98.9,112.2c-4.8,0-8.7,3.8-8.7,8.6 c0,4.7,3.8,8.6,8.5,8.6c4.8,0,8.6-3.7,8.6-8.5C-90.5,116.1-94.2,112.2-98.9,112.2z M-99,128.4c-4.2,0-7.7-3.4-7.7-7.6 s3.4-7.6,7.7-7.6c4.2,0,7.6,3.4,7.6,7.6C-91.4,125-94.8,128.4-99,128.4z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M-245.5-110c-3.1-2-6.1-3.9-9.1-5.9c-0.4-0.3-1-0.5-0.9-1.2c0-0.6,0.5-0.8,1-1.1c0.8-0.4,1.5-0.7,2.3-1.1 c1.1-0.6,2.2-0.6,3.3-0.1c3.9,1.5,7.8,2.9,11.7,4.4c0.6,0.2,1.1,0.2,1.8-0.1c1.8-0.9,3.6-1.8,5.4-2.7c2.1-1.1,4.5-1,6.7-1 c1.6,0,2.5,1.7,1.8,3.3c-1.1,2.7-2.9,4.9-5.5,6.2c-5.7,3-11.5,5.8-17.3,8.7c-0.4,0.2-0.9,0.3-1.3,0.3c-2.6,0-5.3,0-7.9,0 c-0.8,0-1.4-0.2-2-0.9c-1.3-1.6-2.7-3.1-4-4.7c-0.8-0.9-0.7-1.5,0.4-2.1c0.4-0.2,0.8-0.4,1.1-0.6c0.9-0.5,1.7-0.5,2.6,0.1 c0.8,0.5,1.7,1,2.6,1.4c0.3,0.2,0.5,0.3,0.8,0.2C-249.7-107.9-247.6-108.9-245.5-110z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142876765546426261230000000319513782423109029_",
    gradientUnits: "userSpaceOnUse",
    x1: -236.29,
    y1: -33.7467,
    x2: -203.59,
    y2: -33.7467,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142876765546426261230000000319513782423109029_)"
    },
    d: "M-219.9,76.2c-5.1,0-10.3,0-15.4,0 c-0.2,0-0.4,0-0.6,0s-0.4-0.2-0.4-0.5c0-0.2,0.1-0.4,0.4-0.5s0.4,0,0.6,0c10.2,0,20.5,0,30.7,0c0.2,0,0.4,0,0.6,0 c0.2,0,0.4,0.2,0.4,0.5s-0.2,0.5-0.4,0.5c-0.2,0-0.4,0-0.7,0C-209.8,76.2-214.8,76.2-219.9,76.2z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M-258.8-106.9c1.4-1.2,2.7-1.2,4.3-0.2c2.9,1.8,1.9,1.6,4.9,0.2c1.3-0.6,2.6-1.3,4-2c0.5-0.2,1.1-0.4,1.1-1.1 c0-0.7-0.5-0.9-1-1.2c-2.7-1.8-5.5-3.5-8.2-5.2c-0.2-0.2-0.5-0.3-0.8-0.6c1.1-0.5,2.1-1.1,3.1-1.5c0.8-0.4,1.7-0.2,2.5,0.1 c3.9,1.4,7.8,2.9,11.6,4.4c0.9,0.3,1.5,0.3,2.3-0.1c1.9-1,3.7-1.9,5.6-2.8c2-1,4.1-0.9,6.2-0.9c0.9,0,1.4,1.1,0.9,2.1 c-1.1,2.5-2.8,4.5-5.3,5.8c-5.6,2.9-11.3,5.7-16.9,8.5c-0.3,0.2-0.6,0.2-0.9,0.2c-2.7,0-5.3,0-8,0c-0.4,0-0.7,0-1-0.3 C-255.8-103.4-257.3-105.2-258.8-106.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayIcon3);
export default __webpack_public_path__ + "static/media/holiday-icon3.fb32f92c7ad03b082efd2f682c6a02d2.svg";
export { ForwardRef as ReactComponent };